import Alert from "../models/Alert";
export const AlertMixin = {
  data() {
    return {
      alert: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new Alert({
        title: '',
        description: '',
        variant: undefined,
        priority: 1,
        is_active: false,
        display_on_login: false,
        display_on_landing: false,
        published_at: undefined,
        expired_at: undefined
      })
    }
  }
}
